export const DOC_MODE_DEBUG_TOOL_NAME = 'documentMode';
